<template>
  <div>
    <div class="app">
      <router-view />
    </div>
  </div>
</template>
<script>
import IrealVue from "ireal-vue";
import { experiments_to_i18n } from "./i18n";

export default {
  name: "app",
  mixins: [IrealVue.httpMixin],
    metaInfo() {
    return {
      title: "IREAL - Innovative Remote Experimentation for Active Learning",
      meta: [
        {
          name: "description",
          content:
            "Setup scientic experiments from anywhere, at anytime, on your own preferred digital device, and get realistic experimental results in realtime."
        },
        {
          property: "og:title",
          content:
            "IREAL - Innovative Remote Experimentation for Active Learning"
        },
        { property: "og:site_name", content: "IREAL" },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content:
            "https://ireal-preprod.isae.fr/static/labs/" +
            this.route_id +"/" +
            this.route_id +"_poster.jpg"        },
        { name: "robots", content: "index,follow" }
      ]
    };
  },
  async created() {
    //let experiments = await this.getObjectList("experience");
    let locales_experiments = await this.getObjectList(
      "experience/get_locales_experiment"
    );
    experiments_to_i18n(this.$i18n, locales_experiments);
  }
};
</script>
<style scoped>
.app {
  min-height: 600px;
}
</style>
<style>
.btn-transparent {
  border: none !important;
}
</style>
